import { styled } from '@mui/material';
import { PDFViewerViewMode } from './PDFViewer.props';

export const THUMBNAIL_WIDTH = 450;

export const PdfViewerWrapper = styled('div')<{ $viewMode?: PDFViewerViewMode }>(({ $viewMode }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: $viewMode === PDFViewerViewMode.THUMBNAIL ? 'stretch' : 'center',
  height: '100%',
  overflow: 'auto',
  animation: 'fadeInUp 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards',
  '@keyframes fadeInUp': {
    '0%': {
      opacity: 0,
      transform: 'translateY(30px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
}));

export const PdfViewerContentWrapper = styled('div')<{ $viewMode: PDFViewerViewMode }>(({ $viewMode }) => ({
  display: $viewMode === PDFViewerViewMode.THUMBNAIL ? 'grid' : 'flex',
  flexDirection: $viewMode === PDFViewerViewMode.THUMBNAIL ? undefined : 'column',
  gridTemplateColumns:
    $viewMode === PDFViewerViewMode.THUMBNAIL ? `repeat(auto-fill, minmax(${THUMBNAIL_WIDTH}px, 1fr))` : undefined,
  gap: $viewMode === PDFViewerViewMode.THUMBNAIL ? '20px' : '10px',
  padding: $viewMode === PDFViewerViewMode.THUMBNAIL ? '20px' : undefined,
  width: $viewMode === PDFViewerViewMode.THUMBNAIL ? '100%' : undefined,
}));

export const PdfViewerThumbnailWrapper = styled('div')<{ $viewMode: PDFViewerViewMode }>(({ $viewMode }) => ({
  display: $viewMode === PDFViewerViewMode.THUMBNAIL ? 'grid' : 'flex',
  flexDirection: $viewMode === PDFViewerViewMode.THUMBNAIL ? 'row' : 'column',
  gap: $viewMode === PDFViewerViewMode.THUMBNAIL ? '20px' : '10px',
  alignItems: 'center',
  height: '100%',
  overflow: 'auto',
}));

export const PdfViewerStateContainer = styled('div')({
  padding: '20px',
  textAlign: 'center',
});

export const PdfViewerPageContainer = styled('div')<{
  $viewMode: PDFViewerViewMode;
  $isVisible: boolean;
  $isSelected: boolean;
  $width?: number;
}>(({ $viewMode, $isVisible, $isSelected, $width }) => ({
  marginBottom: '20px',
  border: $isSelected ? '3px solid #1976d2' : '1px solid #ddd',
  borderRadius: '8px',
  overflow: 'hidden',
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  // eslint-disable-next-line no-nested-ternary
  minHeight: $viewMode === PDFViewerViewMode.DOCUMENT ? ($isVisible ? 'auto' : '400px') : 'auto',
  width: $viewMode === PDFViewerViewMode.THUMBNAIL ? $width : undefined,
  display: $viewMode === PDFViewerViewMode.THUMBNAIL ? 'flex' : undefined,
  flexDirection: $viewMode === PDFViewerViewMode.THUMBNAIL ? 'column' : undefined,
  opacity: 0,
  transform: 'translateY(20px) scale(0.98)',
  transition: 'all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
  '&.animate-in': {
    opacity: 1,
    transform: 'translateY(0) scale(1)',
  },
}));

export const PdfViewerPageHeader = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: '#f8f9fa',
  padding: '8px 16px',
  borderBottom: '1px solid #ddd',
  fontSize: '14px',
  fontWeight: 'bold',
  color: '#495057',
});

export const PdfPageViewerLoader = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '400px',
  animation: 'pulse 1.5s ease-in-out infinite',
  '@keyframes pulse': {
    '0%': {
      opacity: 0.6,
    },
    '50%': {
      opacity: 1,
    },
    '100%': {
      opacity: 0.6,
    },
  },
});